/**
 * KovaFit - Tu conjunto KovaFit.
 *
 * Cuando la clienta cambia de variante en la ficha, Dawn publica 'variant-change'.
 * - Siempre: el boton "Crear mi conjunto" pasa a llevar el id de la variante
 *   nueva (?kf_items=...), sin pedir nada al servidor.
 * - Solo si cambio el color: se vuelve a pedir la seccion con la variante nueva
 *   (Section Rendering API) y se reemplaza su contenido. La eleccion de la
 *   prenda recomendada vive en Liquid, no se duplica en JS.
 */
if (!customElements.get('kf-outfit')) {
  customElements.define(
    'kf-outfit',
    class KfOutfit extends HTMLElement {
      connectedCallback() {
        if (this.unsubscribe || typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;
        this.unsubscribe = subscribe(PUB_SUB_EVENTS.variantChange, (event) => this.onVariantChange(event));
      }

      disconnectedCallback() {
        if (this.unsubscribe) this.unsubscribe();
        this.unsubscribe = null;
        this.abortController?.abort();
      }

      onVariantChange(event) {
        const variant = event?.data?.variant;
        if (!variant) return;

        this.updateCtaVariant(variant.id);

        const position = parseInt(this.dataset.colorPos, 10) || 0;
        if (!position || !Array.isArray(variant.options)) return;

        const color = String(variant.options[position - 1] || '').trim().toLowerCase();
        if (!color || color === this.dataset.color) return;

        this.abortController?.abort();
        this.abortController = new AbortController();

        const url = `${this.dataset.productUrl}?variant=${variant.id}&section_id=${this.dataset.sectionId}`;
        fetch(url, { signal: this.abortController.signal })
          .then((response) => response.text())
          .then((text) => {
            const fresh = new DOMParser().parseFromString(text, 'text/html').querySelector('kf-outfit');
            if (!fresh) return;
            this.innerHTML = fresh.innerHTML;
            this.dataset.color = fresh.dataset.color || '';
          })
          .catch((error) => {
            if (error.name !== 'AbortError') console.error('[KovaFit] Tu conjunto:', error);
          });
      }

      // Solo reescribe kf_items si el enlace ya lo trae (ajuste activo en el editor).
      updateCtaVariant(variantId) {
        const cta = this.querySelector('[data-kf-outfit-cta]');
        if (!cta || !variantId) return;
        try {
          const url = new URL(cta.getAttribute('href'), window.location.origin);
          if (!url.searchParams.has('kf_items')) return;
          url.searchParams.set('kf_items', String(variantId));
          cta.setAttribute('href', url.pathname + url.search + url.hash);
        } catch (error) {
          // Enlace no parseable: se deja como esta.
        }
      }
    }
  );
}
